import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(tz);

const TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export function datetimeLocalToString(datetimeLocal) {
    if(datetimeLocal.length === 0) {
        return null;
    }
    return (new dayjs(datetimeLocal)).format(TIMESTAMP_FORMAT);
}

export function stringToDatetimeLocal(string) {
    return (new dayjs(string).format('YYYY-MM-DDTHH:mm'))
}


export function nowUTCTimeStamp() {
    return (new dayjs()).utc().format(TIMESTAMP_FORMAT);
}

export function getDSTLocalTime(string) {
    // Format string to remove any timezone formatting
    let formattedString = string;

    if (string === null) return dayjs();

    if (typeof string === 'object') {
        if (string.hasOwnProperty('toUTCString')) {
            string = string.toUTCString();
            formattedString = string;
        }
    }

    if (typeof string === 'string') {
       formattedString = string.substr(0, 24);
    }

    // Get timezone offset of passed date
    const dstOffset = new Date(formattedString).getTimezoneOffset();

    // Make offset a positive number
    const offsetMinutes = Math.abs(dstOffset);

    // Add timezone offset to the passed date
    const date = dayjs(formattedString).add(offsetMinutes, 'minute');

    return date;
}


export function nowTimeStamp() {
    return (new dayjs()).format(TIMESTAMP_FORMAT);
}


export function stringToFriendlyDatetime(string) {
    return (new dayjs(string).format('HH:mm D/M/YYYY'));
}

export function stringToFriendlyDatetimeWithoutTime(string) {
    return (new dayjs(string).format('D/M/YYYY'));
}
